"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_converged__proposition__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f4f20ea9-b564-42ab-b1ba-d6af6b4fc115",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bb972a5a-1c07-4c42-9c6b-64ee855c56fe{fill:#fff;}.b14df51d-50b6-43e7-9b78-0fa051338a9e,.ecf6ee05-8e00-47e6-a520-61844d96e4af{opacity:0.06;}.af0dc1a5-05fe-406d-ae82-30b98d855204,.b14df51d-50b6-43e7-9b78-0fa051338a9e,.b92b9e54-9afa-4938-9cd5-800480df21b5,.e57c991f-3df8-4b03-bd24-2c7066e7c177,.e7ba737f-8cfd-4e6f-9f8c-4029f30a0496{isolation:isolate;}.f28227b6-2142-4df9-97c0-567be3393bff{fill:#333;}.af0dc1a5-05fe-406d-ae82-30b98d855204,.e57c991f-3df8-4b03-bd24-2c7066e7c177{opacity:0.5;}.e57c991f-3df8-4b03-bd24-2c7066e7c177{fill:url(#bbaa74de-bd19-4dd7-9651-9fb1e5eee9a3);}.a8b40a85-f533-4539-ab2e-dabe4c3946b2{fill:#f4f4f4;}.e7ba737f-8cfd-4e6f-9f8c-4029f30a0496{opacity:0.2;fill:url(#b93cb2dd-219a-49e6-8f60-9ac9c6b44069);}.a35dd102-0c9e-4f7f-9754-237c881ca96c,.b84110ee-cb7c-412a-a5ab-3f48a7a7d4a1{fill:none;}.a97cb9fe-e742-4f0d-ae31-421268c28aa6{fill:#e60000;}.b92b9e54-9afa-4938-9cd5-800480df21b5{opacity:0.12;}.b84110ee-cb7c-412a-a5ab-3f48a7a7d4a1{stroke:#ebebeb;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.af0dc1a5-05fe-406d-ae82-30b98d855204{fill:url(#bff0fbb9-4730-4829-b389-66cbce7b9b5f);}.f5190a5e-53ae-4789-b9f5-e8f18bbe8acc{fill:#ebebeb;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bbaa74de-bd19-4dd7-9651-9fb1e5eee9a3",
    x1: -7729.99,
    y1: -8327.05,
    x2: -7622.02,
    y2: -8435.01,
    gradientTransform: "matrix(1, 0, 0, -1, 7772, -8297)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6f6f6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b93cb2dd-219a-49e6-8f60-9ac9c6b44069",
    x1: 729.73,
    y1: -2378.9,
    x2: 729.73,
    y2: -2401.58,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, -2107.24, -1035.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bff0fbb9-4730-4829-b389-66cbce7b9b5f",
    x1: -7643,
    y1: -8394,
    x2: -7593,
    y2: -8444,
    xlinkHref: "#bbaa74de-bd19-4dd7-9651-9fb1e5eee9a3"
  })), /*#__PURE__*/React.createElement("title", null, "converged-proposition-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "f6593e1a-5371-4d44-abd8-ee40950ecb60",
    "data-name": "2ea8409c-a974-4c34-9a3a-f247953cdded"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "bb972a5a-1c07-4c42-9c6b-64ee855c56fe",
    x: 24,
    y: 40.06,
    width: 144,
    height: 95.94,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "b14df51d-50b6-43e7-9b78-0fa051338a9e",
    d: "M164,134.06H28a4,4,0,0,1-4-4V132a4,4,0,0,0,4,4H164a4,4,0,0,0,4-4v-1.94A4,4,0,0,1,164,134.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 42.06,
    width: 139.99,
    height: 83.94,
    rx: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "f28227b6-2142-4df9-97c0-567be3393bff",
    points: "163.99 124.06 28 124 28 44.06 163.99 44.06 163.99 124.06"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e57c991f-3df8-4b03-bd24-2c7066e7c177",
    x: 28,
    y: 44.06,
    width: 135.99,
    height: 79.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "bb972a5a-1c07-4c42-9c6b-64ee855c56fe",
    d: "M70,150.06h0A2,2,0,0,1,71.94,148h48.13a2,2,0,0,1,1.94,2.06h0"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "bb972a5a-1c07-4c42-9c6b-64ee855c56fe",
    x: 86,
    y: 136.06,
    width: 19.99,
    height: 11.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "a8b40a85-f533-4539-ab2e-dabe4c3946b2",
    d: "M122,150v2H70v-2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b14df51d-50b6-43e7-9b78-0fa051338a9e",
    x: 69.99,
    y: 150,
    width: 52,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b14df51d-50b6-43e7-9b78-0fa051338a9e",
    x: 86,
    y: 136.06,
    width: 19.99,
    height: 11.94
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "e7ba737f-8cfd-4e6f-9f8c-4029f30a0496",
    points: "105.99 148 97.87 148.12 85.83 136.08 105.99 136 105.99 148"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bb972a5a-1c07-4c42-9c6b-64ee855c56fe",
    d: "M53.49,142l7.95-3c2-.39,3.82-.11,4.71.84,1.34,1.44,12.4,14.25,13.32,15.37s.8,3.53-1.44,5.28-12.14,8.38-15.2,7.4S47,163,29.77,132.36,16,89.15,16.82,86.11s11.87-7.59,14.59-8.48,4.87.35,5.35,1.66c.55,1.5,5.59,17.39,6.12,19.2.37,1.24-.4,2.9-1.81,4.32S34,109.55,34,109.55s1.33,5.16,7.69,16.45C44.7,131.45,53.49,142,53.49,142Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a35dd102-0c9e-4f7f-9754-237c881ca96c",
    d: "M53.49,142h0l-.13-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a97cb9fe-e742-4f0d-ae31-421268c28aa6",
    d: "M35.84,107.83c-1.55-5-6-19.11-9-28.38-.66.29-1.35.6-2,.93C28,90.49,33,106.12,34,109.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a8b40a85-f533-4539-ab2e-dabe4c3946b2",
    d: "M53.37,141.9l-.07-.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a97cb9fe-e742-4f0d-ae31-421268c28aa6",
    d: "M55.72,141.2l-2.22.8c2.34,2.55,11.32,12.92,19.18,22,.66-.4,1.3-.81,1.9-1.19C67.19,154.32,58.75,144.57,55.72,141.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "ecf6ee05-8e00-47e6-a520-61844d96e4af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34,107.55s.13.5.5,1.53c1.41-1.33,5.42-5.1,6.57-6.27,1.41-1.41,2.17-3.08,1.81-4.32l-.09-.31a6.89,6.89,0,0,1-1.71,2.63C39.68,102.23,34,107.55,34,107.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,158.5c-2.24,1.75-12.14,8.38-15.2,7.4s-15.8-4.9-33-35.54C18.8,110.87,16.24,98.68,16,91.61c-.22,6.67,1.67,19.28,13.75,40.75C47,163,59.75,166.92,62.8,167.9s13-5.65,15.2-7.4a4.25,4.25,0,0,0,1.81-4.57A5,5,0,0,1,78,158.5Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "bb972a5a-1c07-4c42-9c6b-64ee855c56fe",
    x: 132,
    y: 80,
    width: 44,
    height: 88,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "b14df51d-50b6-43e7-9b78-0fa051338a9e",
    d: "M172,166H136a4,4,0,0,1-4-4v2a4,4,0,0,0,4,4h36a4,4,0,0,0,4-4v-2A4,4,0,0,1,172,166Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 88,
    width: 40,
    height: 68,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b92b9e54-9afa-4938-9cd5-800480df21b5",
    x: 151,
    y: 84,
    width: 8,
    height: 1,
    rx: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b92b9e54-9afa-4938-9cd5-800480df21b5",
    x: 148,
    y: 84,
    width: 1,
    height: 1,
    rx: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b92b9e54-9afa-4938-9cd5-800480df21b5",
    cx: 154,
    cy: 161,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "b84110ee-cb7c-412a-a5ab-3f48a7a7d4a1",
    d: "M105.5,98.87a13.47,13.47,0,0,0-19,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be610a3e-e319-4f92-ac06-2a1c5ab49da6",
    "data-name": "a765868d-da7f-469e-930f-ccda4f56b7d2",
    className: "b84110ee-cb7c-412a-a5ab-3f48a7a7d4a1",
    d: "M115,86.92h0a26.94,26.94,0,0,0-38.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b84110ee-cb7c-412a-a5ab-3f48a7a7d4a1",
    d: "M124.53,74.88a40.41,40.41,0,0,0-57.06,0"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f28227b6-2142-4df9-97c0-567be3393bff",
    x: 136,
    y: 90,
    width: 36,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "af0dc1a5-05fe-406d-ae82-30b98d855204",
    x: 136,
    y: 90,
    width: 36,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a35dd102-0c9e-4f7f-9754-237c881ca96c",
    width: 192,
    height: 192
  })), /*#__PURE__*/React.createElement("circle", {
    className: "f5190a5e-53ae-4789-b9f5-e8f18bbe8acc",
    cx: 96,
    cy: 110,
    r: 4
  }));
}

var _default = ic_converged__proposition__dark;
exports.default = _default;